/**
 * @file 工具函数 辅助方法
 */

import bigJs from 'big.js';



/**
 * @description 深度克隆一份对象
 */
export function cloneFn(item) {
    return JSON.parse(JSON.stringify(item))
}


// 检测类型
export function checkTypeFn(item) {
    return Object.prototype.toString.call(item).slice(8, -1);
}



// 断言 必须是对象
export function assertObject(item) {
    if (checkTypeFn(item) == 'Object' && Object.keys(item).length > 0) {
        return item;
    }
    return {};
}
// 断言 必须是数组
export function assertArray(item) {
    if (checkTypeFn(item) == 'Array' && item.length > 0) {
        return item;
    }
    return [];
}
// 断言 必须是字符串
export function assertString(item) {
    if (checkTypeFn(item) == 'String' && item.trim().length > 0) {
        return item.trim();
    }
    return '';
}


// 断言 必须是数字
export function assertNumber(item) {
    if (checkTypeFn(item) == 'Number' && item > 0) {
        return item;
    }
    return 0;
}





// 数据转数字
export function transNumFn(item) {
    if (item) {
        let type = checkTypeFn(item);
        if (type == 'Number' || type == 'BigInt') {
            return item;
        } else if (type == 'String') {
            return transNumFn(item - 0);
        } else {
            return 1;
        }
    } else {
        return 0;
    }
}




export function bigPlus(a, b) { //a+b
    return Number(new bigJs(a).plus(b).toFixed(9))
}

export function bigMinus(a, b) { //a-b
    return Number(new bigJs(a).minus(b).toFixed(9))
}

export function bigTimes(a, b) { //a*b
    return Number(new bigJs(a).times(b).toFixed(9))
}

export function bigDiv(a, b) { //a/b
    return Number(new bigJs(a).div(b).toFixed(9))
}



/*
    @description 获取保留两位小数的字符串数字
    @return <String> 带小数点的字符串数字
*/
export function toDoubleNumFn(item, n = 2) {
    let pow = Math.pow(10, n),
        num = bigTimes(transNumFn(item), pow),
        flag = num < 0 ? '-' : '+',
        abs = Math.abs(num),
        floor = Math.floor(abs) / pow,
        result = `${flag}${floor}` - 0;
    return result.toFixed(n)
}

// 转为保留两位小数的数字类型数据,没有小数的不保留
export const transDoubleNum = (item, n = 2) => transNumFn(toDoubleNumFn(item, n));




// 深层对象获取值
export function objectGet(obj, keyStr) {
    let current = assertObject(obj),
        keyArr = `${keyStr}`.split('.').filter(i => i);
    keyArr.forEach((i, k) => current = k == keyArr.length - 1 ? current[i] : assertObject(current[i]));
    return current;
}

// 深层对象获取对象
export const objectGetObject = (obj, keyStr) => assertObject(objectGet(obj, keyStr));

// 深层对象获取数组
export const objectGetArray = (obj, keyStr) => assertArray(objectGet(obj, keyStr));

// 深层对象获取数字
export const objectGetNum = (obj, keyStr) => transNumFn(objectGet(obj, keyStr));

// 深层对象获取字符串
export const objectGetString = (obj, keyStr) => assertString(objectGet(obj, keyStr));


// 深层对象获取保留两位小数的数字
export const objectGetDoubleNum = (obj, keyStr, n = 2) => transNumFn(toDoubleNumFn(objectGet(obj, keyStr), n));







// 金额输入框 限制输入方法
export function amountInputFn(val) {
    if (!val) val = '';
    if (typeof val !== 'string') val += '';
    if (val.substr(0, 1) === '.') val = '';
    val = val.replace(/^0*(0\.|[1-9])/, '$1'); // 解决 粘贴不生效
    val = val.replace(/[^\d.]/g, ''); // 清除“数字”和“.”以外的字符
    val = val.replace(/^00/, '0'); // 小数前只能输入一个0
    val = val.replace(/^\./g, ''); // 清除. 字符开头
    val = val.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的
    val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
    val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
    if (val.indexOf('.') < 0 && val !== '') {
        if (val.substr(0, 1) === '0' && val.length === 2) {
            val = val.substr(1, val.length);
        }
    }
    return val;
}


export function format_tools(num,type) {

	if(type){
		if (type=="1"){
			return Math.ceil(num)
		}else if(type=="2"){
			return Math.floor(num)
		}else if(type=="3"){
			if(num==0){
				return num;
			}
			return num.toFixed(1)
		}else if(type=="4"){
			if(num==0){
				return num;
			}
			return num.toFixed(0)
		}

	}else{
		return num
	}
}




// WEBPACK FOOTER //
// ./src/utils/tools.js